import { useEffect, useState } from 'react';
import { apiErrorHandling } from '../api/apierrorhandling';
import { generalStore } from '../stores/GeneralStore';
import { getPreorders } from '../api/stoApi';
import { TPreorder } from '../models';
import { UseTranslationResponse } from 'react-i18next';

export const usePreorders = (
  assetId: string,
  filters: {
    page?: number;
    rowsPerPage?: number;
  },
  t: UseTranslationResponse<any>,
) => {
  const [preorders, setPreorders] = useState<{ items: TPreorder[]; count: number }>({ items: [], count: 0 });
  const load = async () => {
    generalStore.setIsLoading(true);
    try {
      const response = (await getPreorders(assetId, filters)).data;
      setPreorders(response.data);
    } catch (error: any) {
      apiErrorHandling(error, t('revenuePools.errors.loadAll'));
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [filters.page, filters.rowsPerPage]);

  return preorders;
};
